<template>
  <div class="box-hd">
    <h2 class="title">视频</h2>
    <div class="more">
      <a href="//www.mi.com/a/h/14933.html" target="_blank" class="more-link">
        查看全部
        <i class="iconfont">&gt;</i>
      </a>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
.xm-plain-box .box-hd {
  position: relative;
  height: 58px;
  -webkit-font-smoothing: antialiased;
  .title{
    margin: 0;
    font-size: 22px;
    font-weight: 200;
    line-height: 58px;
    color: #333;
  }
  .more{
   position: absolute;
    top: 0;
    right: 0; 
    .more-link{
      font-size: 16px;
      line-height: 58px;
      color: #424242;
      -webkit-transition: all .4s;
      transition: all .4s;
      .iconfont{
        width: 12px;
        height: 12px;
        padding: 4px 6px;
        margin-left: 8px;
        border-radius: 16px;
        font-size: 12px;
        line-height: 12px;
        background: #b0b0b0;
        color: #fff;
        vertical-align: 1px;
        -webkit-transition: all .4s;
        transition: all .4s;
      }
    }
  }
  .more a:hover{
    color: #ff6700;
    i:hover{
      background: #ff6700;
    }
  }
}
</style>